import React from 'react';
import { useDetails } from './useDetails';
import { Button, Image, MultiLineEllipsisText } from 'components';
import { CountryDetailsEdit } from './edit';
import { PERMISSIONS } from 'constants/permissions';
import { HasAccess } from 'components/common/accessControl';
import { Col, Row, Tag, Typography, Tooltip } from 'components';
import { EditIconButton, LanguageIcon, OfficialDealerIcon } from 'components/common/icons';
import styles from 'pages/admin/clients/client/details/styles.module.scss';

export const Details = React.memo(() => {
  const { isOpen, onModalClose, countryDetails, onModalOpen } = useDetails();
  return (
    <>
      <Row gutter={[0, 16]}>
        <Col span={24} className={styles.main_info}>
          <Row justify={'space-between'}>
            <Col className={styles.id_container}>
              <Typography.Text className={'font-size-12'} style={{ color: '#525866' }}>
                ID: {countryDetails.uuid}
              </Typography.Text>
            </Col>
            <HasAccess role={PERMISSIONS.countries.country.write}>
              <Button type={'link'} icon={<EditIconButton />} onClick={onModalOpen} />
            </HasAccess>
          </Row>
          <Row gutter={[0, 4]}>
            <Col span={24} className={styles.legal_name}>
              <Typography.Text title={countryDetails.name} className={styles.name}>
                {countryDetails?.flagLocation ? (
                  <Image
                    src={countryDetails?.flagLocation}
                    width={18}
                    height={18}
                    preview={false}
                    style={{ verticalAlign: 'unset', width: 18, marginBottom: -4 }}
                    className={'radius-circle'}
                  />
                ) : (
                  ''
                )}
                <Typography.Text style={{ marginLeft: 8 }}>{countryDetails.commonName}</Typography.Text>
              </Typography.Text>
            </Col>
            <Col span={24}>
              <Row style={{ gap: '9px' }}>
                <Typography.Text className={'font-size-12'} style={{ color: '#99A0AE' }}>
                  {countryDetails.formattedLastModifiedDate}
                </Typography.Text>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col span={24} className={styles.additional_info}>
          <Row gutter={[0, 14]}>
            {countryDetails.regions?.length ? (
              <Col span={24}>
                <Row align={'middle'} className={styles.additional_info_item}>
                  <Tooltip
                    title={
                      countryDetails.regions.length > 1 &&
                      countryDetails.regions.map((i: { name: string }) => i.name).join(', ')
                    }
                  >
                    <Typography.Text type={'secondary'} className={'font-size-14'}>
                      {countryDetails.regions[0].name}{' '}
                      {countryDetails.regions?.length > 1 ? (
                        <Typography.Text underline>+{countryDetails.regions?.length - 1}</Typography.Text>
                      ) : (
                        ''
                      )}
                    </Typography.Text>
                  </Tooltip>
                </Row>
              </Col>
            ) : (
              ''
            )}
            {countryDetails.subRegions?.length ? (
              <Col span={24}>
                <Row align={'middle'} className={styles.additional_info_item}>
                  <Tooltip title={countryDetails.subRegions.length > 1 && countryDetails.subRegions?.join(', ')}>
                    <Typography.Text type={'secondary'} className={'font-size-14'}>
                      {countryDetails.subRegions[0]}{' '}
                      {countryDetails.subRegions?.length > 1 ? (
                        <Typography.Text underline>+{countryDetails.subRegions?.length - 1}</Typography.Text>
                      ) : (
                        ''
                      )}
                    </Typography.Text>
                  </Tooltip>
                </Row>
              </Col>
            ) : (
              ''
            )}
            {countryDetails.languages?.length ? (
              <Col span={24}>
                <Row align={'middle'} className={styles.additional_info_item}>
                  <LanguageIcon />
                  <Tooltip
                    title={
                      countryDetails.languages?.length > 1 &&
                      countryDetails.languages.map((i: { name: string }) => i.name).join(', ')
                    }
                  >
                    <Typography.Text type={'secondary'} className={'font-size-14'}>
                      {countryDetails.languages[0].name}{' '}
                      {countryDetails.languages?.length > 1 ? (
                        <Typography.Text underline>+{countryDetails.languages?.length - 1}</Typography.Text>
                      ) : (
                        ''
                      )}
                    </Typography.Text>
                  </Tooltip>
                </Row>
              </Col>
            ) : (
              ''
            )}
            {countryDetails.officialDealer ? (
              <Col span={24}>
                <Row align={'middle'} className={styles.additional_info_item}>
                  <OfficialDealerIcon />
                  <Typography.Text type={'secondary'} className={'font-size-14'}>
                    Official Dealer
                  </Typography.Text>
                </Row>
              </Col>
            ) : (
              ''
            )}
            {/*TODO system generated tags*/}
          </Row>
        </Col>
        <Col span={24} className={styles.manual_tags}>
          <Row className={styles.tag_container}>
            {countryDetails.manualTags?.map((_tag: string, index: number) => (
              <Tag title={_tag} key={index + _tag} className={'custom-tag'}>
                {_tag}
              </Tag>
            ))}
          </Row>
        </Col>
        <Col span={24}>
          <MultiLineEllipsisText subTitle={'Additional Notes:'} text={countryDetails.additionalNotes} />
        </Col>
      </Row>
      <CountryDetailsEdit open={isOpen} onCancel={onModalClose} />
    </>
  );
});
